export const OPEN_ADD_FORM_MODAL = 'OPEN_ADD_FORM_MODAL';
export const CLOSE_ADD_FORM_MODAL = 'CLOSE_ADD_FORM_MODAL';

function openAddFormModal(parentForm, addImyLayer) {
  return {
    type: OPEN_ADD_FORM_MODAL,
    parentForm,
    addImyLayer,
    isAddFormModalShown: true,
    results: null
  };
}

function closeAddFormModal() {
  return {
    type: CLOSE_ADD_FORM_MODAL,
    parentForm: null,
    addImyLayer: false,
    isAddFormModalShown: false,
    isAddingForm: false,
    addingFormResults: null
  };
}

export function showAddFormModal(parentForm, addImyLayer) {
  return (dispatch) => {
    dispatch(openAddFormModal(parentForm, addImyLayer));
  };
}

export function hideAddFormModal() {
  return (dispatch) => {
    dispatch(closeAddFormModal());
  };
}
